import { useState, useContext, useEffect } from 'react';
import Context from '../components/context.js';
import { AccessContext } from '../components/context.js';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const Merch = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [id, setId] = useState(location.state?.id);
    const setContext = useContext(Context)[1];
    const { role, metaData, firstName, lastName } = useContext(AccessContext);
    var _s = undefined;
    if (role == "Host/Guest")
        _s = { id: metaData.speakerId, firstName, lastName };
    if (id)
        setContext('Edit Merch');
    else
        setContext('Add Merch');
    const defaultMerch = {
        imageUrl: '',
        name: '',
        description: '',
        price: 0,
        createdDate: '',
        createdBy: '',
        updatedDate: '',
        updatedBy: '',
        images: [],
        productSizes: false,
        sizeType: 0,
        sizes: [],
        subscriptionExclusive: false,
        exclusivePricing: false,
        freeShipping: false
    }
    const [merch, setMerch] = useState(defaultMerch);
    const [imagesToDelete, setImagesToDelete] = useState([]);
    const [loading, setLoading] = useState(id ? true : false);
    const [file, setFile] = useState(null);
    const [fp, setFP] = useState('');
    const [deleteImage, setDeleteImage] = useState(false);
    const loadMerch = () => {
        axios.post(process.env.REACT_APP_API_URL + 'merch', {
            id: id
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                r.data.results.images = r.data.results.images ?? [];
                if (r.data.results.imageUrl) {
                    r.data.results.images.splice(0, 0, r.data.results.imageUrl);
                    r.data.results.imageUrl = '';
                }
                setMerch({...defaultMerch, ...r.data.results});
            }
        });
    }
    useEffect(() => {
        if (id) {
            loadMerch();
        } else {
            setLoading(false);
        }
    }, [id]);
    const setValue = (key, value) => {
        setMerch(h => {
            let _h = { ...h };
            _h[key] = value;
            return _h;
        });
    }
    const removeImage = (i) => {
        setImagesToDelete(_itd => {
            var itd = [..._itd];
            var m = {...merch};
            itd.push(...merch.images.splice(i, 1));
            setMerch(m);
            console.log(itd);
            return itd;
        })
    }
    const save = () => {
        const formData = new FormData();
        if (file != null) {
            for (var i = 0; i < Math.min(file.length, 10); i++) {
                formData.append('image', file[i]);
            }
        }
        formData.append('name', merch.name);
        formData.append('price', merch.price);
        formData.append('description', merch.description);
        formData.append('speakerId', location.state?.speaker?.id || _s?.id || null);
        formData.append('imgUrl', merch.imageUrl);
        formData.append('imageJson', JSON.stringify(merch.images));
        formData.append('productSizes', merch.productSizes ? 1 : 0);
        formData.append('sizeType', merch.sizeType);
        formData.append('sizeJson', JSON.stringify(merch.sizes));
        formData.append('subscriptionExclusive', merch.subscriptionExclusive ? 1 : 0);
        formData.append('exclusivePricing', merch.exclusivePricing ? 1 : 0);
        formData.append('freeShipping', merch.freeShipping ? 1 : 0);
        if (!id) {
            axios.post(process.env.REACT_APP_API_URL + 'merch/add', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(r => {
                if (r?.data?.status === 'Success') {
                    toast.success('Saved');
                    setId(r.data.id);
                    setFile(null);
                    setFP('');
                    setDeleteImage(false);
                    setLoading(true);
                }
            });
        } else {
            formData.append('imagesToDelete', JSON.stringify(imagesToDelete));
            formData.append('id', id);
            axios.post(process.env.REACT_APP_API_URL + 'merch/update', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(r => {
                if (r?.data?.status === 'Success') {
                    toast.success('Saved');
                    setFile(null);
                    setFP('');
                    setDeleteImage(false);
                    setLoading(true);
                    loadMerch();
                }
            });
        }
    }
    const _delete = () => {
        if (!id)
            return;
        axios.post(process.env.REACT_APP_API_URL + 'merch/delete', {
            ids: JSON.stringify([id]),
            urls: JSON.stringify([merch.imageUrl])
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                navigate('/merch-list');
            }
        });
    }
    const filterArrays = (arrA, arrB) => {
        return (arrA || []).filter(a => {
            return !(arrB || []).some(b => {
                return a.id === b.id;
            });
        });
    }
    const toggleSizes = (size) => {
        setMerch(m => {
            let _m = { ...m };
            if (_m.sizes.includes(size)) {
                const idx = _m.sizes.indexOf(size);
                if (idx !== -1) _m.sizes.splice(idx, 1);
            } else {
                _m.sizes.push(size);
            }
            return _m;
        });
    }
    const clothingSizes = [
        "XS", "S", "S/M", "M", "M/L", "L", "L/XL", "XL", "XXL"
    ];
    const shoeSizes = [
        "4", "4.5", "5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5",
        "10", "10.5", "11", "11.5", "12", "12.5", "13", "13.5", "14",
        "S", "M", "L", "XL"
    ];
    const bottleSizes = [
        "S", "M", "L", "375 ML", "750 ML", "1 L", "1.5 L"
    ];
    if (loading) {
        return (
            <div className="loading mt-50" style={{ color: '#AAA5BF' }}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        )
    }
    return (
        <main>
            <div className="container w-100">
                <div className="form speaker-form f-start">
                    <div className="w-50 sm-w-100 b-radius-4 b-1 p-10 p-rel bg-white">
                        <h3 className="mb-10">Merch Info</h3>
                        <div className="w-100 gap-10 f-row f-wrap a-center">
                            <div className="w-30 mw-250">
                                <label htmlFor="image-file">Product Image - Square Format</label>
                                <input type="file" id="image-file" accept="image/*" multiple onChange={(e) => { setFile(e.target.files); setFP(e.target.value); console.log(e.target.value); console.log(e.target.files); }} value={fp} />
                            </div>

                            {merch.images.length > 0 ? merch.images.map( (img, i) => (
                                <div className="p-rel w-30 mw-150 f-col f-center">
                                    <img key={i} className="sqr-img" src={process.env.REACT_APP_MEDIA_URL + img} alt={merch.name} />
                                    <button className="btn-remove-media" onClick={() => {
                                        removeImage(i);
                                    }}>
                                        {'\u00D7'}
                                    </button>
                                </div>
                            )) : null}
                            
                            <div className="w-100"></div>
                            <div className="w-80">
                                <label htmlFor="name">Product Name</label>
                                <input type="text" id="name" value={merch.name} onChange={(e) => setValue('name', e.target.value)} />
                            </div>
                            <div className="w-20">
                                <label htmlFor="price">Product Price</label>
                                <input type="text" style={{ textAlign: 'right' }} id="price" value={'$' + (parseFloat(merch.price.toFixed(2).replace(/[^0-9]/g, '')) / 100).toFixed(2)} onChange={(e) => setValue('price', parseFloat(e.target.value.replace(/[^0-9]/g, '')) / 100)} />
                            </div>
                            <div className="w-100">
                                <label htmlFor="description">Description</label>
                                <textarea rows="6" id="description" value={merch.description} onChange={(e) => setValue('description', e.target.value)} />
                            </div>
                            <div className="w-100 flex gap-5 f-row">
                                <label htmlFor="add-sizes" className="mb-0">Add Product Sizes</label>
                                <input type="checkbox" id="add-sizes" checked={merch.productSizes} onClick={(e) => setValue('productSizes', e.target.checked)} />
                                {merch.productSizes == true && (
                                    <>
                                        <label htmlFor="add-sizes" className="mb-0 ml-15">Clothing</label>
                                        <input type="checkbox" id="add-sizes" checked={merch.sizeType == 0} onClick={(e) => {setValue('sizeType', 0); merch.sizes = []}} />
                                        <label htmlFor="add-sizes" className="mb-0 ml-5">Shoes</label>
                                        <input type="checkbox" id="add-sizes" checked={merch.sizeType == 1} onClick={(e) => {setValue('sizeType', 1); merch.sizes = []}} />
                                        <label htmlFor="add-sizes" className="mb-0 ml-5">Bottles</label>
                                        <input type="checkbox" id="add-sizes" checked={merch.sizeType == 2} onClick={(e) => {setValue('sizeType', 2); merch.sizes = []}} />
                                    </>
                                )}
                            </div>
                            <div className="w-100" style={{display: merch.productSizes ? 'block' : 'none'}}>
                                <div className="flex f-row w-100 f-wrap gap-5">
                                    {merch.sizeType == 0 && clothingSizes.map(s => (
                                        <div key={s} className="flex f-row min-w-50 w-10 b-1 b-radius-3 p-5 cursor-pointer" onClick={e => toggleSizes(s)}>
                                            <label htmlFor={s} className="ml-auto mb-0" style={{ pointerEvents: 'none' }}>{s}</label>
                                            <input type="checkbox" className="ml-auto" id={s} style={{ pointerEvents: 'none' }} checked={merch.sizes.includes(s)} />
                                        </div>
                                    ))}
                                    {merch.sizeType == 1 && shoeSizes.map(s => (
                                        <div key={s} className="flex f-row min-w-50 w-10 b-1 b-radius-3 p-5 cursor-pointer" onClick={e => toggleSizes(s)}>
                                            <label htmlFor={s} className="ml-auto mb-0" style={{ pointerEvents: 'none' }}>{s}</label>
                                            <input type="checkbox" className="ml-auto" id={s} style={{ pointerEvents: 'none' }} checked={merch.sizes.includes(s)} />
                                        </div>
                                    ))}
                                    {merch.sizeType == 2 && bottleSizes.map(s => (
                                        <div key={s} className="flex f-row min-w-50 w-10 b-1 b-radius-3 p-5 cursor-pointer" onClick={e => toggleSizes(s)}>
                                            <label htmlFor={s} className="ml-auto mb-0" style={{ pointerEvents: 'none' }}>{s}</label>
                                            <input type="checkbox" className="ml-auto" id={s} style={{ pointerEvents: 'none' }} checked={merch.sizes.includes(s)} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="flex f-row w-100 f-wrap f-between gap-5">
                                <div className="flex gap-5 f-row" style={{flex: 0}}>
                                    <label htmlFor="subExc" className="mb-0" style={{width: 'max-content'}}>Subscription Exclusive</label>
                                    <input type="checkbox" id="subExc" checked={merch.subscriptionExculsive} onClick={(e) => setValue('subscriptionExculsive', e.target.checked)} />
                                </div>
                                <div className="flex gap-5 f-row" style={{flex: 0}}>
                                    <label htmlFor="excPricing" className="mb-0" style={{width: 'max-content'}}>Exclusive Pricing</label>
                                    <input type="checkbox" id="excPricing" checked={merch.exclusivePricing} onClick={(e) => setValue('exclusivePricing', e.target.checked)} />
                                </div>
                                <div className="flex gap-5 f-row" style={{flex: 0}}>
                                    <label htmlFor="freeShipping" className="mb-0" style={{width: 'max-content'}}>Free Shipping</label>
                                    <input type="checkbox" id="freeShipping" checked={merch.freeShipping} onClick={(e) => setValue('freeShipping', e.target.checked)} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="w-100 f-end f-row">
                        <div className="flex f-center f-row gap-5">
                            <button onClick={save} className="btn btn-green">Save</button>
                            {id && <button onClick={() => {
                                setId(null);
                                setMerch(defaultMerch);
                                setFile(null);
                                setFP('');
                                setDeleteImage(false);
                                setLoading(true);
                            }} className="btn">New</button>}
                            <Link className="btn btn-red" to={location.state?.returnTo ? location.state?.returnTo : "/merch-list"} state={location.state?.speaker ? {id: location.state?.speaker.id} : null}>Cancel</Link>
                            {id && <button onClick={_delete} className="btn btn-red">Delete</button>}
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default Merch;